export default __webpack_public_path__ + "static/media/invest_ilust1.063ddaa0.png";